<template>
  <article class="popup recovery-success">
    <p class="message" v-html="$t('login.recoveryText')">

    </p>
    <router-link :to="'/login'"
                 @click="closeAll"
                 class="btn btn-green">{{$t('btns.enter')}}</router-link>
    <close-btn></close-btn>
  </article>
</template>

<script>
  import closeBtn from '../closeBtn'
  import {popups} from "../../../mixins/popups";

  export default {
    name: 'recoverySuccess',
    components: {
      closeBtn
    },
    mixins: [popups]
  }
</script>

<style scoped lang="scss">
  .recovery-success {
    width: 350px;
    height: 150px;
    text-align: center;
    font-family: $mr;
    font-size: 16px;
    color: $darkBlue;
    text-transform: uppercase;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
  }

  .btn {
    margin-top: 40px;
  }


</style>
